import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import InputSelect from '../../components/InputGroup/InputSelect';
import MobileInput from '../../components/InputGroup/MobileInput';
import { ReactComponent as InfoIcon } from '../../assets/plus_icon/incentive_pending.svg';
import PhoneInput from 'react-phone-input-2';
import { ALL_REGEX } from '../../config/static';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import { getCities } from '../../services/private/csv.service';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { getClosingManagerByProjectIds } from '../../services/public/public.service';
import { ReactComponent as RefreshIcon } from '../../assets/plus_icon/refresh.svg';

const customStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '54px',
        minWidth: '100%',
        borderRadius: '8px',
        fontSize: '18px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: '12px',
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        backgroundColor: state.isDisabled ? "#ececedff" : (state.isSelected ? "#f1f1f5" : styles.backgroundColor),
        color: state.isDisabled ? '#a1a1a5' : '#44444f',
        zIndex: 99,
        "&:hover": {
            color: state.isDisabled ? '#6f6f70ff' : "#44444f",
            backgroundColor: state.isDisabled ? "#fafafb" : "#f1f1f5"
        },
    }),
};

const InfoList = [
    {
        label: 'Event',
        value: 'Event'
    },
    {
        label: 'Website',
        value: 'Website'
    },
    {
        label: 'SMS',
        value: 'SMS'
    },
    {
        label: 'WhatsApp',
        value: 'WhatsApp'
    },
    {
        label: 'Facebook/Instagram',
        value: 'Facebook/Instagram'
    },
    {
        label: 'Newspaper',
        value: 'Newspaper'
    },
    // {
    //     label: 'Channel Partner',
    //     value: 'Channel Partner'
    // },
    {
        label: 'Direct Walking',
        value: 'Direct Walking'
    },
    {
        label: 'Hoarding',
        value: 'Hoarding'
    },
    {
        label: 'PreSales',
        value: 'PreSales'
    },
    {
        label: 'Reference',
        value: 'Reference'
    },
    {
        label: 'Other',
        value: 'Other'
    }
]

const CustomerDetails = ({
    setChannelPartner,
    isWithCP,
    detail,
    handleChangeDetail,
    investement,
    setInvestment,
    purpose,
    setPurpose,
    preference,
    setPrefrence,
    altMobile,
    setAltMobile,
    mobile,
    setMobile,
    setAboutProject,
    aboutProject,
    possessionPreference,
    setPossessionPreference,
    others,
    setOthers,
    referralMobile,
    setReferralMobile,
    referralName,
    setReferralName,
    society,
    setSociety,
    flatNo,
    setFlatNo,
    city,
    setCity,
    closingManager,
    setClosingManager,
    isRevisit,
    projectId,
    formConfig,
    projectName
}) => {
    const [error, setError] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailDomainError, setEmailDomainError] = useState(false);
    const [mobileError, setMobileError] = useState(false);
    const [referenceMobileError, setReferenceMobileError] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [isRefreshing, setIsRefreshing] = useState(false);

    const getSourceLabel = (field) => {
        let label = field.label;
        if (!label) {
            return `How did you find out about the ${projectName || ''}?`.replace(/\s+/g, ' ').replace(' ?', '?').trim();
        }
        
        let formatted = label;
        if (formatted.includes('this Project')) {
            formatted = formatted.replace('this Project', `the ${projectName || ''}`);
        } else if (formatted.includes('this')) {
            formatted = formatted.replace('this', `the ${projectName || ''}`);
        }
        
        if (formatted.includes('Project')) {
            if (formatted.includes('about') && !formatted.includes('about the')) {
                formatted = formatted.replace('about', `about the ${projectName || ''}`).replace('Project', '');
            } else {
                formatted = formatted.replace('Project', projectName || '');
            }
        }
        
        return formatted.replace(/\s+/g, ' ').replace(' ?', '?').trim();
    };

    const isManagerRequired = allUsers && allUsers.length > 0;
    const isManagerInvalid = isManagerRequired && !closingManager;

    const fetchClosingManagers = () => {
        if (!projectId) return;
        setIsRefreshing(true);
        getClosingManagerByProjectIds({ project_ids: [projectId] }).then(res => {
            if (res.status === 200) {
                const managerData = res.data.data.map((data) => ({
                    label: data.name,
                    value: data.uuid,
                    isBusy: data.is_busy === true
                }));
                setAllUsers(managerData);
            }
        }).catch(err => {
            console.log("Error fetching closing managers:", err);
        }).finally(() => {
            setIsRefreshing(false);
        });
    };

    useEffect(() => {
        fetchClosingManagers();
    }, [projectId]);

    useEffect(() => {
        if (isWithCP) {
            setAboutProject('')
            setReferralMobile('')
            setReferralName('')
            setSociety('');
            setFlatNo('');
            setOthers()
        }
    }, [isWithCP]);

    useEffect(() => {
        const unloadCallback = (event) => {
            event.preventDefault();
            event.returnValue = "";
            return "";
        };

        // window.addEventListener("popstate", handleBackButton);
        window.addEventListener("beforeunload", unloadCallback);

        return () => {
            // window.removeEventListener("popstate", handleBackButton);
            window.removeEventListener("beforeunload", unloadCallback);
        };

    }, []);

    const handleSubmit = () => {
        let isInvalid = false;
        
        // If formConfig is loaded, dynamically validate enabled & required fields
        if (formConfig && formConfig.basic_details) {
            formConfig.basic_details.fields.forEach(field => {
                if (field.enabled && field.required) {
                    if (field.key === 'customer_mobile' && !mobile) {
                        isInvalid = true;
                    } else if (field.key === 'closing_user_uuid' && isManagerInvalid) {
                        isInvalid = true;
                    } else if (field.key === 'customer_name' && !detail.name) {
                        isInvalid = true;
                    } else if (field.key === 'email' && !detail.email) {
                        isInvalid = true;
                    } else if (field.key === 'other_source' && !isWithCP && !aboutProject) {
                        isInvalid = true;
                    }
                }
            });

            // Special conditional check for referral details
            if (!isWithCP && aboutProject === 'Reference' && (!referralName || !referralMobile)) {
                isInvalid = true;
            }
        } else {
            // Fallback static validation
            if (!mobile || !detail.name || !detail.email || isManagerInvalid || (!isWithCP && !aboutProject) || (!isWithCP && aboutProject === 'Reference' && (!referralName || !referralMobile))) {
                isInvalid = true;
            }
        }

        if (isInvalid) {
            setError(true);
            const sourceEl = document.getElementById('source');
            const formEl = document.getElementById('customer-form');
            if ((!isWithCP && !aboutProject) || (aboutProject === 'Reference' && (!referralName || !referralMobile))) {
                if (sourceEl) sourceEl.scrollIntoView({ behavior: 'smooth', block: "end", inline: "nearest" });
            } else {
                if (formEl) formEl.scrollIntoView({ behavior: "smooth" });
            }
            return;
        } else {
            setError(false);
        }

        // Email Error check (only if email is entered and enabled)
        const emailField = formConfig?.basic_details?.fields?.find(f => f.key === 'email');
        if ((!formConfig || (emailField && emailField.enabled)) && detail.email && !ALL_REGEX.EMAIL.test(detail.email)) {
            setEmailError(true);
            setEmailDomainError(false);
            return;
        } else {
            setEmailError(false);
        }

        // Email Domain check (block propacity.in, propacity.com, paropacity.com)
        const emailStr = (detail.email || '').toLowerCase().trim();
        const isBlockedDomain = emailStr.endsWith('@propacity.in') || emailStr.endsWith('@propacity.com') || emailStr.endsWith('@paropacity.com');
        if ((!formConfig || (emailField && emailField.enabled)) && detail.email && isBlockedDomain) {
            setEmailDomainError(true);
            return;
        } else {
            setEmailDomainError(false);
        }

        // Mobile Error check
        if (mobile && mobile.length < 12) {
            setMobileError(true);
            return;
        } else {
            setMobileError(false);
        }

        // Error check for source field referral option
        if ((!isWithCP && aboutProject === 'Reference' && referralMobile) && referralMobile.length < 12) {
            const sourceEl = document.getElementById('source');
            if (sourceEl) sourceEl.scrollIntoView({ behavior: 'smooth', block: "end", inline: "nearest" });
            setReferenceMobileError(true);
            return;
        } else {
            setReferenceMobileError(false);
        }

        if (isWithCP) {
            setChannelPartner('4');
        } else {
            setChannelPartner('5');
        }
    };

    const loadOptions = (city) => {
        return getCities(city)
            .then((res) => {
                if (res.data.status === 200) {

                    const cities = res.data?.data.map((city) => {
                        return {
                            label: city.name,
                            value: city.name
                        }
                    });
                    return cities;
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const renderField = (field) => {
        const isRequired = field.required;
        switch (field.key) {
            case 'customer_mobile':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <PhoneInput
                            inputClass={'border !w-full focus:outline-none focus:border-primary rounded-xl !text-gray800 !font-medium text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                            country={'in'}
                            value={mobile}
                            countryCodeEditable={false}
                            enableSearch={true}
                            disableSearchIcon={true}
                            onChange={phone => setMobile(phone)}
                            disabled={true}
                        />
                        <div className=' flex items-center gap-2 sm:!text-sm text-xs text-[#314056] !mt-4'>
                            <span><InfoIcon /></span> Make sure this is your registered mobile no. on whatsapp.
                        </div>
                        {error && !mobile && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Mobile No.</div>
                        )}
                        {mobileError && mobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>}
                    </div>
                );
            case 'closing_user_uuid':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <div className="flex items-center gap-3 w-full">
                            <div className="flex-1 min-w-0">
                                <Select
                                    options={allUsers}
                                    placeholder={'Select Closing Manager'}
                                    styles={customStyles}
                                    value={closingManager}
                                    onChange={(value) => setClosingManager(value)}
                                    isClearable={true}
                                    isDisabled={isRevisit}
                                    formatOptionLabel={(option) => (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                            <span>{option.label}</span>
                                            {option.isBusy && (
                                                <span style={{ fontSize: '13px', fontWeight: '500', color: '#ea4335' }}>
                                                    (Busy)
                                                </span>
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                            <button
                                type="button"
                                onClick={fetchClosingManagers}
                                disabled={isRefreshing || isRevisit}
                                style={{ height: '54px', width: '54px' }}
                                className="flex items-center justify-center rounded-xl border border-gray-300 bg-white hover:bg-gray-50 active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer flex-shrink-0"
                                title="Refresh closing managers list"
                            >
                                <RefreshIcon className={`w-6 h-6 text-gray-500 ${isRefreshing ? 'spin-animation' : ''}`} />
                            </button>
                        </div>
                        {error && isManagerInvalid && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Select Closing Manager</div>
                        )}
                    </div>
                );
            case 'customer_name':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            name='name'
                            value={detail.name}
                            onChange={handleChangeDetail}
                            placeholder={'Enter First Name'}
                        />
                        {error && !detail.name && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Name</div>
                        )}
                    </div>
                );
            case 'email':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter E-Mail'}
                            name='email'
                            value={detail.email}
                            onChange={handleChangeDetail}
                        />
                        {error && !detail.email && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Email</div>
                        )}
                        {emailError && detail.email && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Email</div>
                        )}
                        {emailDomainError && detail.email && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Propacity emails are not allowed</div>
                        )}
                    </div>
                );
            case 'alt_mobile':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <PhoneInput
                            inputClass={'border !w-full focus:outline-none focus:border-primary !text-gray800 !font-medium rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                            country={'in'}
                            value={altMobile}
                            countryCodeEditable={false}
                            enableSearch={true}
                            disableSearchIcon={true}
                            onChange={phone => setAltMobile(phone)}
                        />
                    </div>
                );
            case 'address':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter Address '}
                            name='address'
                            value={detail.address}
                            onChange={handleChangeDetail}
                        />
                    </div>
                );
            case 'city':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <AsyncCreatableSelect
                            cacheOptions
                            loadOptions={loadOptions}
                            customStyles={customStyles}
                            defaultOptions
                            placeholder='Search and Select City'
                            value={city ? { label: city, value: city } : ''}
                            styles={customStyles}
                            onChange={(e) => setCity(e.value)}
                            menuPosition='fixed'
                        />
                    </div>
                );
            case 'pincode':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"number"}
                            placeholder={'Enter Pincode'}
                            name='pincode'
                            value={detail.pincode}
                            onChange={handleChangeDetail}
                        />
                    </div>
                );
            case 'age':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"number"}
                            placeholder={'Enter Age'}
                            name='age'
                            value={detail.age}
                            onChange={handleChangeDetail}
                        />
                    </div>
                );
            case 'profession':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter Profession'}
                            name='profession'
                            value={detail.profession}
                            onChange={handleChangeDetail}
                        />
                    </div>
                );
            case 'company':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter Company'}
                            name='company'
                            value={detail.company}
                            onChange={handleChangeDetail}
                        />
                    </div>
                );
            case 'designation':
                return (
                    <div key={field.key} className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                        <label className='sm:!text-lg text-base !mb-3 '>{field.label}{isRequired && <sup className='text-red'>*</sup>}</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter Designation'}
                            name='designation'
                            value={detail.designation}
                            onChange={handleChangeDetail}
                        />
                    </div>
                );
            case 'other_source':
                return !isWithCP && (
                    <div key={field.key} className='w-full flex items-center' id='source'>
                        <div className={`flex-col font-medium relative w-full hidden sm:flex`}>
                            <label className='sm:!text-lg text-base !mb-3 '>{getSourceLabel(field)}{isRequired && <sup className='text-red'>*</sup>}</label>
                            <Select
                                options={InfoList}
                                placeholder={'Select option'}
                                styles={customStyles}
                                value={aboutProject ? InfoList.find(i => i.value === aboutProject) : ''}
                                onChange={(value) => setAboutProject(value.value)}
                            />
                            {error && !aboutProject && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Select Project Source</div>
                            )}
                        </div>
                        <div className={` flex flex-col font-medium w-full sm:hidden`}>
                            <label className='sm:!text-lg text-base !mb-3 '>{getSourceLabel(field)}{isRequired && <sup className='text-red'>*</sup>}</label>
                            <InputSelect
                                options={InfoList}
                                placeholder={'Select option'}
                                value={aboutProject ? InfoList.find(i => i.value === aboutProject) : ''}
                                onChange={(value) => setAboutProject(value.value)}
                            />
                            {error && !aboutProject && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Select Project Source</div>
                            )}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    const activeFields = formConfig?.basic_details?.fields?.filter(f => f.enabled) || [
        { key: 'customer_mobile', required: true, enabled: true, label: 'Mobile No.' },
        { key: 'closing_user_uuid', required: true, enabled: true, label: 'Closing Manager' },
        { key: 'customer_name', required: true, enabled: true, label: 'Name' },
        { key: 'email', required: true, enabled: true, label: 'E-Mail' },
        { key: 'alt_mobile', required: false, enabled: true, label: 'Alternate No.' },
        { key: 'address', required: false, enabled: true, label: 'Address' },
        { key: 'city', required: false, enabled: true, label: 'City' },
        { key: 'pincode', required: false, enabled: true, label: 'Pincode' },
        { key: 'age', required: false, enabled: true, label: 'Age' },
        { key: 'profession', required: false, enabled: true, label: 'Profession' },
        { key: 'other_source', required: true, enabled: true, label: `How did you find out about the ${projectName || ''}?`.replace(/\s+/g, ' ').replace(' ?', '?').trim() }
    ];

    const fieldRows = [];
    let currentRow = [];
    activeFields.forEach(field => {
        if (field.key === 'other_source') {
            if (currentRow.length > 0) {
                fieldRows.push(currentRow);
                currentRow = [];
            }
            fieldRows.push([field]);
        } else {
            currentRow.push(field);
            if (currentRow.length === 2) {
                fieldRows.push(currentRow);
                currentRow = [];
            }
        }
    });
    if (currentRow.length > 0) {
        fieldRows.push(currentRow);
    }

    const getInventoryState = (key) => {
        if (key === 'possession_preference') return { value: possessionPreference, setter: setPossessionPreference };
        if (key === 'preference') return { value: preference, setter: setPrefrence };
        if (key === 'investement') return { value: investement, setter: setInvestment };
        if (key === 'purpose') return { value: purpose, setter: setPurpose };
        return { value: '', setter: () => {} };
    };

    return (
        <div className=' mx-auto overflow-visible'>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .spin-animation {
                    animation: spin 1s linear infinite;
                }
            `}</style>
            <div className='flex items-center sm:justify-center bg-white rounded-xl !py-6 md:!py-12 z-10 !sticky !-top-6'>
                <button className='flex items-center static ml-4 sm:ml-0  sm:absolute sm:left-5 md:left-10 ' onClick={() => setChannelPartner('2')}>
                    <LeftArrowIcon className='stroke-black800 rotate-180 mr-1' /> <span className='hidden sm:inline-block'>Back</span>
                </button>
                <p className='flex flex-col sm:flex-row text-lg sm:text-2xl font-semibold mb-0 !ml-4 !sm:ml-0'>
                    Customer {isWithCP ? 'with CP' : 'Self Check-in'} - <span className='text-[#2064FA] ml-1'>{projectName}</span>
                </p>
            </div>
            <div className=' bg-white rounded-xl !mt-6 !p-5 md:!p-10' id='customer-form'>
                <div className='sm:!mt-6 space-y-4 sm:space-y-6'>
                    <div className='sm:!text-xl text-lg font-semibold text-gray800'>Basic Details</div>
                    {fieldRows.map((row, idx) => (
                        <div key={idx} className="w-full flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-6">
                            {row.map(field => renderField(field))}
                        </div>
                    ))}
                    {aboutProject === 'Other' && <div className={`flex flex-col font-medium relative w-full`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Other Source</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            name='name'
                            value={others}
                            onChange={(e) => setOthers(e.target.value)}
                            placeholder={'Enter Other Source'}
                        />

                    </div>}
                    {
                        aboutProject === 'Reference' && <>
                            <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Reference Name <sup className='text-red'>*</sup></label>
                                    <input
                                        className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                        type={"text"}
                                        placeholder={'Enter Reference Name '}
                                        name='address'
                                        value={referralName}
                                        onChange={(e) => setReferralName(e.target.value)}
                                    />
                                    {error && !referralName && (
                                        <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Reference Name</div>

                                    )}
                                </div>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Reference Mobile <sup className='text-red'>*</sup></label>
                                    <PhoneInput
                                        inputClass={'border !w-full focus:outline-none focus:border-primary !text-gray800 !font-medium rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                                        // containerClass={classname}
                                        country={'in'}
                                        value={referralMobile}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        disableSearchIcon={true}
                                        onChange={phone => {
                                            setReferralMobile(phone)
                                        }}
                                    />
                                    {error && !referralMobile && (
                                        <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Reference Mobile No</div>

                                    )}
                                    {
                                        referenceMobileError && referralMobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                                    }
                                </div>


                            </div>
                            <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Society </label>
                                    <input
                                        className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                        type={"text"}
                                        placeholder={'Enter Society'}
                                        name='address'
                                        value={society}
                                        onChange={(e) => setSociety(e.target.value)}
                                    />
                                    {/* {error && !detail.address && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Address</div>

                            )} */}
                                </div>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Flat No</label>
                                    <input
                                        className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                        type={"text"}
                                        placeholder={'Enter Flat No'}
                                        name='address'
                                        value={flatNo}
                                        onChange={(e) => setFlatNo(e.target.value)}
                                    />
                                </div>

                            </div>
                        </>
                    }
                    <div className='!border !border-dashed !my-7 sm:!my-10'></div>
                    <div className='sm:!text-xl text-lg font-semibold text-gray800'>Inventory Preference</div>
                    {formConfig?.inventory_preference?.fields ? (
                        formConfig.inventory_preference.fields
                            .filter(field => field.enabled)
                            .map(field => {
                                const state = getInventoryState(field.key);
                                return (
                                    <div key={field.key} className="flex flex-col font-medium position-relative">
                                        <label className="sm:!text-lg text-base !mb-3">{field.label}</label>
                                        <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-6">
                                            {field.options?.map(opt => {
                                                const isChecked = state.value === opt.value;
                                                return (
                                                    <div
                                                        key={opt.value}
                                                        className={`w-max rounded-full flex items-center text-lg border cursor-pointer ${isChecked ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'} px-4 md:!px-6 py-2 md:!py-4`}
                                                        onClick={() => state.setter(opt.value)}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name={field.key}
                                                            value={opt.value}
                                                            className="accent-white"
                                                            checked={isChecked}
                                                            readOnly
                                                        />
                                                        <label className="ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0 cursor-pointer">{opt.label}</label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })
                    ) : (
                        <>
                            <div className={` flex flex-col font-medium position-relative`}>
                                <label className='sm:!text-lg text-base !mb-3'>Possession Preference</label>
                                <div className='grid grid-cols-2 sm:flex gap-6'>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Dec 25' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setPossessionPreference('Dec 25')}
                                    >
                                        <input
                                            type="radio"
                                            name="possession"
                                            id=""
                                            value='Dec 25'
                                            className='accent-white'
                                            checked={possessionPreference === 'Dec 25'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Dec 25</label>
                                    </div>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Dec 26' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setPossessionPreference('Dec 26')}
                                    >
                                        <input
                                            type="radio"
                                            name="possession"
                                            id=""
                                            className='accent-white'
                                            value={'Dec 26'}
                                            checked={possessionPreference === 'Dec 26'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Dec 26</label>
                                    </div>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Dec 27' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setPossessionPreference('Dec 27')}
                                    >
                                        <input
                                            type="radio"
                                            name="possession"
                                            id=""
                                            className='accent-white'
                                            value={'Dec 27'}
                                            checked={possessionPreference === 'Dec 27'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Dec 27</label>
                                    </div>
                                </div>
                            </div>
                            <div className={` flex flex-col font-medium position-relative`}>
                                <label className='sm:!text-lg text-base !mb-3'>Preferred Configuration</label>
                                <div className=' grid grid-cols-2 md:flex gap-6'>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${preference === '2 BHK' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'} px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setPrefrence('2 BHK')}
                                    >
                                        <input
                                            type="radio"
                                            name="Preferred"
                                            id=""
                                            value={'2 BHK'}
                                            className='accent-white'
                                            checked={preference === '2 BHK'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>2 BHK</label>
                                    </div>
                                </div>
                            </div>

                            <div className={` flex flex-col font-medium position-relative`}>
                                <label className='sm:!text-lg text-base !mb-3'>How much you would like to invest?</label>
                                <div className='grid grid-cols-2 sm:flex gap-6'>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${investement === '45L-50L' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setInvestment('45L-50L')}
                                    >
                                        <input
                                            type="radio"
                                            name="invest"
                                            id=""
                                            className='accent-white'
                                            value={'45L-50L'}
                                            checked={investement === '45L-50L'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>45L-50L</label>
                                    </div>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${investement === '50L-55L' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setInvestment('50L-55L')}
                                    >
                                        <input
                                            type="radio"
                                            name="invest"
                                            id=""
                                            className='accent-white'
                                            value={'50L-55L'}
                                            checked={investement === '50L-55L'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>50L-55L</label>
                                    </div>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${investement === '60L-75L' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setInvestment('60L-75L')}
                                    >
                                        <input
                                            type="radio"
                                            name="invest"
                                            id=""
                                            className='accent-white'
                                            value={'60L-75L'}
                                            checked={investement === '60L-75L'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>60L-75L</label>
                                    </div>
                                </div>
                            </div>

                            <div className={` flex flex-col font-medium position-relative`}>
                                <label className='sm:!text-lg text-base !mb-3 '>Purpose of Purchase?</label>
                                <div className='flex gap-6'>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${purpose === 'end use' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setPurpose('end use')}
                                    >
                                        <input
                                            type="radio"
                                            name="Purpose"
                                            value={'end use'}
                                            id=""
                                            className='accent-white'
                                            checked={purpose === 'end use'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>End Use</label>
                                    </div>
                                    <div
                                        className={`w-max rounded-full flex items-center text-lg border ${purpose === 'investment' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5]' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                        onClick={() => setPurpose('investment')}
                                    >
                                        <input type="radio"
                                            name="Purpose"
                                            value={'investment'}
                                            id=""
                                            className='accent-white'
                                            checked={purpose === 'investment'}
                                        />
                                        <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Investment</label>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div className='w-full flex flex-col-reverse sm:flex-row items-center sm:space-x-6 space-y-reverse space-y-4 sm:space-y-0'>

                        <button className='w-full sm:w-1/2 text-base sm:!text-lg border rounded-xl !py-2  sm:!py-3.5' onClick={() => {
                            setChannelPartner('2')
                        }}>Back</button>
                        <button className='w-full sm:w-1/2 text-base sm:!text-lg rounded-xl !py-2  sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                            handleSubmit()
                        }}>Next</button>

                    </div>
                </div>

            </div>

        </div>
    )
}

export default CustomerDetails